// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_e6-0";
export var headerCellHover = "_e6-1";